import React, { FC } from 'react';

import StyledLoader from './styled';

const Loader: FC<{ size?: number; isDark?: boolean }> = ({ size = 14, isDark = true }) => (
  <StyledLoader size={size} isDark={isDark} />
);

export default Loader;
